import React from "react";

class PointsMenu extends React.Component {
  render() {
    return (
      <div className="main-container-loyalty">
        <h3 className="base-heading">SET YOUR LOYALTY PROGRAM</h3>
        <p className="sub-heading">Select how customers will earn points</p>

        <div className="loyalty-menu-options">
          <div className="loyalty-menu-container" onClick={()=>this.props.changeView('earn_points')}>
            <img className="loyalty-menu-image" src="/amountSpent.svg" />
            <h3 className="loyalty-menu-heading">Earn by Amount Spent</h3>
            <p className="loyalty-menu-subheading">
              Customer's who visits your store for Shopping will get points
            </p>
          </div>
          <div className="loyalty-menu-container">
            <img className="loyalty-menu-image" src="/nonSpent.svg" />
            <h3 className="loyalty-menu-heading">Non-spend Activities</h3>
            <p className="loyalty-menu-subheading">Coming Soon</p>
          </div>
        </div>
      </div>
    );
  }
}

export default PointsMenu;



// WEBPACK FOOTER //
// ./src/containers/LoyaltySetup/PointsMenu.js